import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import FadeInAnimation from '../../utils/FadeInAnimation';
import { clickTracking } from '../../utils/tracking';

import ErrorBoundary from '@shared/ErrorBoundary';

import './affix-styles.scss';
import * as styles from './styles.module.scss';

const menuItems = [
  { id: 'home', vocab: 'home_nav', href: '#', track: 'Home' },
  { id: 'about', vocab: 'about_nav', href: '#about', track: 'About' },
  { id: 'playmakers-near-you', vocab: 'playmakers_nav', href: '#playmakers', track: 'Playmakers near you' },
  { id: 'stories', vocab: 'stories_nav', href: '#stories', track: 'Stories' },
];

const Menu = () => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);

  const forceCloseMenu = () => {
    setChecked(false);
  };

  const onCbChange = () => {
    setChecked((s) => !s);
  };

  const renderMenuItems = () =>
    menuItems.map((d) => (
      <li key={`item${d.id}`} className={styles.navigationItem}>
        <a
          className={`${styles.navigationItemLink} js-tracking-link`}
          data-tracking={JSON.stringify({
            ...clickTracking,
            action: d.track,
            more: { section_reference: 'playmakers', interaction: d.track },
          })}
          href={d.href}
          onClick={forceCloseMenu}
        >
          <span className={styles.caption}>{t(d.vocab)}</span>
        </a>
      </li>
    ));

  const stickyHeaderOptions = JSON.stringify({
    navigationClass: '',
    stickyHeader: true,
    selectActiveItem: false,
    stickyThreshold: 50,
    forceUseStickyThreshold: true,
  });

  return (
    <ErrorBoundary>
      <div className='navigation'>
        <nav role='navigation' className='d3-plugin' data-plugin='stickyheader' data-options={stickyHeaderOptions}>
          <div className={`${styles.navigationWrap} js-sticky-wrap navigation__wrap`}>
            <FadeInAnimation className={`${styles.navigationContainer} navigation__container`} delay={250} offset={0}>
              <a className={`${styles.navigationLogo} navigation__logo`} href='/'>
                <img
                  alt='Playmakers'
                  title='Playmakers'
                  data-sizes='auto'
                  className='pflazyload'
                  data-srcset={`${window.imgBaseUrl}/imgml/uefacom/playmakers/main-logo` + '.svg'}
                />
              </a>

              <ul className={styles.navigationMenu}>{renderMenuItems()}</ul>

              <div className={styles.navigationToggleMenu}>
                <input type='checkbox' checked={checked} onChange={onCbChange} />
                <div>
                  <span className={styles.navigationToggleMenuLine} />
                  <span className={styles.navigationToggleMenuLine} />
                  <span className={styles.navigationToggleMenuLine} />
                  <ul className={styles.navigationMenuInsideToggle}>{renderMenuItems()}</ul>
                </div>
              </div>
            </FadeInAnimation>
          </div>
        </nav>
      </div>
    </ErrorBoundary>
  );
};

export default memo(Menu);
